import React from 'react';
import {Redirect} from 'react-router'
import '../css/MenuItem.css';

import ItemImage from "./ItemImage";
import ItemProduct from "./ItemProduct";
import ItemStore from "./ItemStore";
import Product from "../Modules/Product";

class MainMenuItem extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            id: props.item.id,
            image: props.item.image,
            has_extra_items: props.item.has_extra_items,
            type: props.item.type,
            link: props.item.link,
            stores_id: props.item.stores_id,
            products_id:props.item.products_id,
            products: props.item.products,
            stores:props.item.stores,
            ads_type:props.item.ads_type,
            name:props.item.name,
        };
    }
    componentWillReceiveProps(props) {
        this.setState(
            {
                id: props.item.id,
                image: props.item.image,
                type: props.item.type,
                link: props.item.link,
                stores_id: props.item.stores_id,
                products_id:props.item.products_id,
                products: props.item.products,
                stores:props.item.stores,
                ads_type:props.item.ads_type,
                name:props.item.name,
            });

    }
    componentWillMount = () => {
    };
    componentDidMount() {
    }


    render() {

        if(this.state.type == 'IMAGE')
            return(<ItemImage image={this.state.image} type={this.state.ads_type} link={this.state.link} products_id={this.state.products_id} stores_id={this.state.stores_id}/> );
        else if( this.state.type == 'PRODUCT'){
            let products = [];
            this.state.products.forEach((product)=>{
                products.push(new Product(product));
            });
            return(<ItemProduct  products={products} id={this.state.id} name={this.state.name} has_extra_items={this.state.has_extra_items}/> );
        }

        else if( this.state.type == 'STORE')
            return(<ItemStore  stores={this.state.stores} id={this.state.id} name={this.state.name} has_extra_items={this.state.has_extra_items}/> );
        else return'' ;
    }

}



export default MainMenuItem;
